import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useStore } from "../../helpers";
import { AddRequestType } from "../../new-features";
import { observer } from "mobx-react-lite";

interface RowActionsProps {
  row: any;
  selectedRows: Set<number>;
  tableData: any[];
  setTableData: any;
  editRowId: number | null;
  setEditRowId: any;
  editRowValues: any;
  setEditRowValues: any;
}

export const RowActions = observer(
  ({
    row,
    selectedRows,
    tableData,
    setTableData,
    editRowId,
    setEditRowId,
    editRowValues,
    setEditRowValues,
  }: RowActionsProps) => {
    const { t } = useTranslation("data_table");

    const rootStore = useStore();
    const { serviceRequestsStore } = rootStore;

    // ⭐ Always fetch the latest updated row
    const freshRow =
      tableData.find((r) => r.id === row.original.id) || row.original;

    // DELETE ROW
    const handleDelete = () => {
      const updated = tableData.filter((r) => r.id !== row.original.id);
      setTableData([...updated]); // force new reference → rerender
    };

    // EDIT ROW
    const handleEdit = () => {
      serviceRequestsStore.update_modal_status("addRequestType", true);
      serviceRequestsStore.setActiveRequestType(freshRow);
      console.log("Editing row:", freshRow);
    };

    return (
      <>
        <button
          onClick={handleEdit}
          className="text-[#1b1b1d] px-2 py-1 rounded text-sm"
        >
          <FontAwesomeIcon
            icon="pen-to-square"
            className="rct-icon rct-icon-half-check"
          />
        </button>

        <button
          onClick={handleDelete}
          className="text-[#1b1b1d] px-2 py-1 rounded text-sm"
        >
          <FontAwesomeIcon
            icon="trash"
            className="rct-icon rct-icon-half-check"
          />
        </button>

        {/* Auto-renders Add/Edit modal */}
        <AddRequestType />
      </>
    );
  }
);
